import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { cn } from "@/shared/lib";

import type { DrillItem } from "../../model/Drill";

const PROGRESS = msg({ message: "Answered {answered} of {total}" });

const GRADE_DOT = {
  right: "bg-good",
  close: "bg-warn",
  wrong: "bg-bad",
} as const;

type ProgressDotsProps = { items: DrillItem[]; current: number };

// Точки серии: решённые — цветом оценки, текущая — кольцом, впереди — пустые.
export const ProgressDots = ({ items, current }: ProgressDotsProps) => {
  const { i18n } = useLingui();
  const answered = items.filter((item) => item.attempt !== null).length;
  return (
    <div
      role="img"
      aria-label={i18n._({ ...PROGRESS, values: { answered, total: items.length } })}
      className="flex items-center gap-2"
    >
      {items.map((item, index) => (
        <span
          key={item.drill_id}
          className={cn(
            "block size-3.5 rounded-full",
            item.attempt !== null && GRADE_DOT[item.attempt.grade],
            item.attempt === null && index === current && "border-2 border-accent bg-background",
            item.attempt === null && index !== current && "bg-sidebar-active",
          )}
        />
      ))}
    </div>
  );
};
